import React from "react";

const ChildCategoryInputSelect = ({
  label,
  options,
  onChange,
  name,
  value,
}) => {
  return (
    <div className="form-group">
      <label style={{ fontWeight: "bold" }} htmlFor="category">
        {label}
      </label>
      <select
        className="form-control form-control-sm"
        id="category"
        onChange={onChange}
        name={name}
      >
        <option value="">choose</option>
        {options?.map((item, index) => (
          <option
            key={index}
            selected={item.value === value}
            value={item?.value}
          >
            {item?.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ChildCategoryInputSelect;
